import { EnumScopes } from './enum-scopes';

export class Property {
    public name!: string;
    public value!: string;
    public legacy!: boolean;
}
